import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkipNavigationLink',
  setup(__props) {


const skipNavigationElement = ref<Element[] | any>([]);

const clickedSkipNavigation = () => {
    const elementToSkipTo: any = document.querySelector('main');
    elementToSkipTo.tabIndex = 0;
    elementToSkipTo.focus();
    elementToSkipTo.scrollIntoView();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref: skipNavigationElement.value,
    role: "button",
    class: "skip-navigation",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clickedSkipNavigation()), ["prevent"]))
  }, _toDisplayString(_ctx.$dictionary.get('Global/A11y/SkipNavigation')), 513))
}
}

})